import { isNonEmptyString } from "src/services/predicates";

export function generateKey(str: string): string {
  return str
    .trim() // Remove leading/trailing whitespace
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // Remove non-alphanumeric, non-space, non-hyphen chars
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-"); // Replace multiple hyphens with a single hyphen
}

/**
 * Mark as user generated key when value is not empty and not equal to generated slug
 */
export function isUserGeneratedKey(
  key: string | undefined | null,
  title: string | undefined | null
): boolean {
  const isKeyEmpty = !isNonEmptyString(key);
  const isTitleEmpty = !isNonEmptyString(title);

  // If both title and key are empty/null/undefined, then this is NOT user generated key
  if (isKeyEmpty && isTitleEmpty) {
    return false;
  }

  // if title is empty, but key is not, then this is user generated key
  if (isTitleEmpty) {
    return true;
  }

  // if key is not empty, and key is not equal to generated key, then this is user generated key
  return !isKeyEmpty && key !== generateKey(title);
}
